module.exports = __webpack_public_path__ + "static/media/under16-mission2-graphic.909fde2e.png";